(function () {
  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function selectedParts(builder) {
    return Array.from(builder.querySelectorAll('[data-builder-select]'))
      .map((select) => {
        const option = select.selectedOptions[0];
        if (!option || !option.value) return null;
        return {
          id: Number(option.value),
          quantity: 1,
          title: option.dataset.title || option.textContent.trim(),
          label: select.dataset.slotLabel || 'Componente',
          price: Number(option.dataset.price || 0),
          url: option.dataset.url || ''
        };
      })
      .filter(Boolean);
  }

  function updateBuilder(builder) {
    const parts = selectedParts(builder);
    const total = parts.reduce((sum, part) => sum + part.price, 0);
    const totalNode = builder.querySelector('[data-builder-total]');
    const list = builder.querySelector('[data-builder-list]');
    const addButton = builder.querySelector('[data-builder-add]');
    const whatsapp = builder.querySelector('[data-builder-whatsapp]');

    if (totalNode) totalNode.textContent = formatMoney(total);

    if (list) {
      list.innerHTML = parts.length
        ? parts.map((part) => `<li><strong>${part.label}:</strong> ${part.title} - ${formatMoney(part.price)}</li>`).join('')
        : '<li>Selecciona componentes disponibles para calcular el setup.</li>';
    }

    if (addButton) {
      addButton.disabled = parts.length === 0;
    }

    if (whatsapp) {
      const base = builder.dataset.whatsappBase || 'Hola, quiero cotizar este setup:';
      const number = builder.dataset.whatsappNumber || '';
      const lines = parts.map((part) => `${part.label}: ${part.title} (${formatMoney(part.price)})`);
      const text = `${base}\n\n${lines.join('\n')}\n\nTotal estimado: ${formatMoney(total)}\nCompatibilidad sujeta a revisión técnica.`;
      whatsapp.href = number ? `https://wa.me/${number}?text=${encodeURIComponent(text)}` : '#';
    }
  }

  function initBuilder(builder) {
    const selects = Array.from(builder.querySelectorAll('[data-builder-select]'));
    const addButton = builder.querySelector('[data-builder-add]');

    selects.forEach((select) => {
      select.addEventListener('change', () => updateBuilder(builder));
    });

    addButton?.addEventListener('click', () => {
      const parts = selectedParts(builder);
      if (!parts.length) return;

      addButton.disabled = true;
      addButton.textContent = 'Agregando setup...';

      const items = parts.map((part) => ({ id: part.id, quantity: 1 }));
      const request = window.MegavCart?.addItems
        ? window.MegavCart.addItems(items)
        : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

      Promise.resolve(request)
        .then(() => {
          addButton.textContent = 'Setup agregado';
        })
        .catch(() => {
          addButton.textContent = 'No se pudo agregar';
        })
        .finally(() => {
          window.setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = 'Agregar setup al carrito';
          }, 1100);
        });
    });

    updateBuilder(builder);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-pc-builder]').forEach(initBuilder);
  });
})();
